import { render, staticRenderFns } from "./WeeklyVisitsRegistry.vue?vue&type=template&id=a245d770&"
import script from "./WeeklyVisitsRegistry.vue?vue&type=script&lang=js&"
export * from "./WeeklyVisitsRegistry.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports